export default __webpack_public_path__ + "static/media/philadelphia.b49f3c05.png";